import types from '../mutation-types';
import FlowsAPI from '../../api/flows';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getFlows(_state) {
    return _state.records;
  },
  getFlow: _state => id =>
    _state.records.find(record => record.id === Number(id)),
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_FLOW_UI_FLAG, { isFetching: true });
    try {
      const { data } = await FlowsAPI.get();
      commit(types.SET_FLOWS, data.payload);
    } finally {
      commit(types.SET_FLOW_UI_FLAG, { isFetching: false });
    }
  },

  show: async ({ commit }, id) => {
    commit(types.SET_FLOW_UI_FLAG, { isFetching: true });
    try {
      const { data } = await FlowsAPI.show(id);
      commit(types.EDIT_FLOW, data.payload);
      return data.payload;
    } finally {
      commit(types.SET_FLOW_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, flow) => {
    commit(types.SET_FLOW_UI_FLAG, { isCreating: true });
    try {
      const { data } = await FlowsAPI.create(flow);
      commit(types.ADD_FLOW, data);
      return data;
    } finally {
      commit(types.SET_FLOW_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...payload }) => {
    commit(types.SET_FLOW_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await FlowsAPI.update(id, payload);
      commit(types.EDIT_FLOW, data.payload);
      return data.payload;
    } finally {
      commit(types.SET_FLOW_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_FLOW_UI_FLAG, { isDeleting: true });
    try {
      await FlowsAPI.delete(id);
      commit(types.DELETE_FLOW, id);
    } finally {
      commit(types.SET_FLOW_UI_FLAG, { isDeleting: false });
    }
  },

  clone: async ({ commit }, id) => {
    const { data } = await FlowsAPI.clone(id);
    commit(types.ADD_FLOW, data.payload);
    return data.payload;
  },
};

export const mutations = {
  [types.SET_FLOW_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  [types.SET_FLOWS]($state, records) {
    $state.records = records || [];
  },
  [types.ADD_FLOW]($state, record) {
    if (!record) return;
    $state.records = [
      record,
      ...$state.records.filter(item => item.id !== record.id),
    ];
  },
  [types.EDIT_FLOW]($state, record) {
    if (!record) return;
    const index = $state.records.findIndex(item => item.id === record.id);
    if (index === -1) $state.records.push(record);
    else $state.records.splice(index, 1, record);
  },
  [types.DELETE_FLOW]($state, id) {
    $state.records = $state.records.filter(item => item.id !== Number(id));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
